import script from "./customDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./customDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__